// Libraries
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
//Services
import { RegisterService } from '../services/RegisterService';

@Component({
    selector: 'user-set-password',
    template: require('./ChoosePasswordComponent.html'),
    styles: [require('./ChoosePasswordComponent.sass')],
})

export class ChoosePasswordComponent implements OnInit {
    message: string;
    messageType: string;
    private redirectUrl = "login";
    private newPassword: string;
    private confirmNewPassword: string;

    private formSubmitted: boolean = false;
    private token: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private registerService: RegisterService
    ) { }
    
    ngOnInit() {
        // Get token string from URL.
        this.route.params.forEach((params: Params) => {
            this.token = params['token'];
        });
        
        // Verify if token is valid or not.
        this.verifyToken();
    }

    // Called when user submit form
    onSubmit() {
        // Mark form as submitted to disable submit button
        this.formSubmitted = true;
        
        // Reset form alert message 
        this.message = "";
        this.messageType = "";

        // Process set new password
        this.setNewPassword();
    }

    private verifyToken() {
        this.registerService.verifyActivationToken(this.token)
            .subscribe(
                complete => {
                    this.formSubmitted = false;
                },
                error => {
                    this.message = "Token not found or expired.";
                    this.messageType = "alert";
                    // Set form as submitted to prevent user post their new password
                    this.formSubmitted = true;
                }
            );
    }

    private setNewPassword() {
        this.registerService.setPasswordWithActivationToken(this.token, this.newPassword)
            .subscribe(
                    complete => {
                        this.message = "Set password successfully. You will be redirected to Login Page in 5 seconds.";
                        this.messageType = "success";
                        
                        // Delay 5s before redirect to login page
                        setTimeout( () => {
                            this.redirect();
                        }, 5000);
                    },
                    error => {
                        this.message = "There is an issue when setting new password.";
                        this.messageType = "alert";
                        this.formSubmitted = false;
                    }
            );
    }

    private redirect() {
        // Redirect to stored url
        this.router.navigate([this.redirectUrl]);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/register/ChoosePasswordComponent.ts